<h3 class="vehicle-subheader" matSubheader>Tags</h3>
<ul>
  <li *ngFor="let item of vehicle.tags">{{ item.name }}</li>
</ul>
<button
  *ngIf="gs.checkPermission(['admin.fleetrw', 'admin.fleetmgr'])"
  class="float-controls" (click)="showOptions()">
  <img src="assets/img/more-navbar.svg" alt="more-navbar">
</button>
